const emailValidator = (input: string) => {
  const validateEmailRegex = /^\S+@\S+\.\S+$/;
  return validateEmailRegex.test(input);
};

export default emailValidator;
